app.controller("QuestionnaireWindowController", [
    "$scope", "$http", "QuestionnairesService", "$uibModalInstance", "params", "toastr", "$rootScope",
    function ($scope, $http, QuestionnairesService, $uibModalInstance, params, toastr, $rootScope) {
        $scope.state = "progress";
        $scope.questionnaire = params.questionnaire;
        $scope.canMoveToNext = true;
        $scope.chunkCount = null;
        var chunks = [];
        $scope.currentPage = null;
        $scope.currentChunkIndex = 0;
        $scope.questions = [];
        $scope.canClose = params.questionnaire.mandatory === false || false;
        $scope.mandatoryDate = new Date($scope.questionnaire.questionnaire.mandatoryDate);
        $scope.currentDate = new Date();


        $scope.getR = function (n) {
            $scope.testRange = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
            return $scope.testRange.slice(0, n);
        };

        function initQuestionnaire(data) {
            var currentChunk = [];
            var previousAnswers = null;

            if ($scope.questionnaire.answers.length !== 0) {
                previousAnswers = $scope.questionnaire.answers.map(function (el) {
                    return el.question;
                });
            }


            data.forEach(function (el) {
                if (el.type === "break") {
                    chunks.push(currentChunk);
                    currentChunk = [];
                } else {
                    currentChunk.push(el);
                }
            });
            chunks.push(currentChunk);

            $scope.chunkCount = chunks.length;

            if (previousAnswers !== null) {
                chunks.forEach(function (chunk, ind) {
                    chunk.forEach(function (el) {
                        if (previousAnswers.indexOf(el._id) !== -1) {
                            $scope.currentChunkIndex = ind + 1;
                        }
                    });
                    if(chunk.length === 0) {
                        $scope.currentChunkIndex = ind + 1;
                    }
                });
            }

            $scope.questions = chunks[$scope.currentChunkIndex];
        }

        //manipulate objects for adding
        var allQuestions = params.questionnaire.questionnaire.questions.map(function (el) {
            if (el.type === "multiple" || el.type === "multiple&text") {
                el.multiple = el.options.map(function (el) {
                    return {value: el, checked: false};
                });
            }
            return el;
        });

        initQuestionnaire(allQuestions);

        $scope.radioTextSelected = function (question, option) {

            if (option === "other-option") {
                question.answer = "";
            } else {
                question.answer = option;
            }
        };

        $scope.ignore = function () {
            QuestionnairesService.ignore($scope.questionnaire._id).then(function () {
                $uibModalInstance.close();
            }).catch(function () {
                $uibModalInstance.close();
            });
        };

        $scope.close = function () {
            $uibModalInstance.close();
        };

        $scope.dismiss = function () {
            $uibModalInstance.dismiss();
        };

        $scope.next = function (saveAndClose) {
            var canMoveToNext = true;
            for (var question in $scope.questions) {
                var slideQuestion = $scope.questions[question];
                if (slideQuestion.mandatory) {

                    if (slideQuestion.type === "radio" && !slideQuestion.answer) {
                        canMoveToNext = false;
                    }

                    if (slideQuestion.type === "radio&text" && !slideQuestion.answer) {
                        canMoveToNext = false;
                    }

                    if (slideQuestion.type === "multiple") {
                        var multipleCheck = false;
                        for (var option in slideQuestion.multiple) {
                            if (slideQuestion.multiple[option].checked) multipleCheck = true
                        }
                        if (!multipleCheck) {
                            canMoveToNext = false;
                        }
                    }

                    if (slideQuestion.type === "multiple&text") {
                        var multipleAndTextCheck = false;
                        for (var single in slideQuestion.multiple) {
                            if (slideQuestion.multiple[single].checked) multipleAndTextCheck = true
                        }
                        if (!multipleAndTextCheck && !slideQuestion.answer) {
                            canMoveToNext = false;
                        }
                    }

                    if (slideQuestion.type === "text" && !slideQuestion.answer) {
                        canMoveToNext = false;
                    }

                    if (slideQuestion.type === "range" && !slideQuestion.answer) {
                        canMoveToNext = false;
                    }
                }
            }

            $scope.canMoveToNext = canMoveToNext;

            if (!$scope.canMoveToNext) {
                return;
            }

            // object to send to api
            var requestData = {};
            requestData.questions = $scope.questions
                .filter(function (el) {
                    return el.type !== 'lineTitle' && el.type !== 'break';
                })
                .map(function (el) {
                    var answer = null;
                    if (el.type === "multiple" || el.type === "multiple&text") {
                        answer = el.multiple
                            .filter(function (e) {
                                return e.checked
                            })
                            .map(function (e) {
                                return e.value
                            });

                        if (el.type === "multiple&text" && el.selection && el.answer !== "") {
                            answer.push(el.answer);
                        }

                        if (answer.length === 0) {
                            answer = null;
                        }
                    } else {
                        if (el.answer !== "" && el.answer !== null && el.answer !== undefined) {
                            answer = [el.answer];
                        }
                    }
                    return {questionId: el._id, answer: answer}
                });

            requestData.questionnaireId = $scope.questionnaire.questionnaire._id;
            requestData.questionnaireInfo = $scope.questionnaire._id;


            QuestionnairesService.answer(requestData).then(function () {
                if(saveAndClose) {
                    toastr.success("კითხვარი შენახულია. გმადლობთ");
                    $uibModalInstance.close();
                    return;
                }

                $scope.currentChunkIndex += 1;

                $scope.questions = chunks[$scope.currentChunkIndex];

                if (chunks.length < $scope.currentChunkIndex + 1) {
                    toastr.success("კითხვარის შევსება დასრულებულია. გმადლობთ");
                    $rootScope.$broadcast('questionnairesCount', {});
                    $uibModalInstance.close();
                }
            }).catch(function () {
                toastr.error("დაფიქსირდა ხარვეზი");
                $scope.canClose = true;
            });
        };

        $scope.closeWarning = function () {
            $scope.canMoveToNext = true;
        };
    }
]);
